import { FunctionComponent } from "react";
import { GameInfoProps } from "../../type";
import { Rule } from "./type";
import GoldRushBonanzaUtils from "./utils";

export const GoldRushBonanzaRuleView: FunctionComponent<GameInfoProps> = ({
  data,
}) => {
  const {
    payouts = {},
    buyFreeSpinRate = 50,
    givenFreeSpin = {},
  } = data as Rule;
  const candyPayouts = Object.entries(payouts);
  const halfCandyCount = candyPayouts.length / 2;
  const payoutElement = [
    <tr key={2} className="text-center">
      {candyPayouts.slice(halfCandyCount).map(([symbol, payout], i) => (
        <td key={`symbol-${symbol}`}>
          <div className="d-inline-block symbol">
            {GoldRushBonanzaUtils.convertSymbol(+symbol)}
          </div>
          <div className="">{payout}</div>
        </td>
      ))}
    </tr>,
    <tr key={1} className="text-center">
      {candyPayouts.slice(0, halfCandyCount).map(([symbol, payout], i) => (
        <td key={`symbol-${symbol}`}>
          <div className="d-inline-block symbol">
            {GoldRushBonanzaUtils.convertSymbol(+symbol)}
          </div>
          <div className="">{payout}</div>
        </td>
      ))}
    </tr>,
  ];
  const specialSymbols = [
    <tr key={1} className="text-center">
      {[4, 2, 3].map((symbol) => (
        <td key={`symbol-${symbol}`}>
          <div className="d-inline-block symbol">
            {GoldRushBonanzaUtils.convertSymbol(+symbol)}
          </div>
        </td>
      ))}
    </tr>,
  ];
  return (
    <>
      <h5 className="card-title">Game Rules</h5>
      <div className="card-text">
        <h6>Payout Table</h6>
        <br />
        <table className="w-100">
          <tbody>{payoutElement}</tbody>
        </table>
      </div>
      <p className="card-text">
        Gold Rush Bonanza Slots is a cascading Match-3 slot game, with a free
        spin meter and new exciting bonus payouts in the theme of Gold Rush
        Bonanza! <br />
      </p>
      <p className="card-text">
        Simply press the Spin button and watch the reels spin, match 4 symbols
        or more for payouts.
      </p>
      <br />
      <p className="card-text">
        The more symbols matched, the higher the payout!{" "}
      </p>
      <br />
      <p className="card-text">
        <img src="/grb/grb_triggered.png" alt="triggered" width="250" />
        <br />
        Wins the payout corresponding to the symbol matched
        <br />
      </p>
      <br />

      <h6>Multiplier</h6>
      <p className="card-text">
        <br />
        <img src="/grb/grb_multiplier.png" alt="triggered" width="250" />
        <br />
        Multiplier symbol is present, multiply the total amount of multiplier
        symbols by the winnings of that round
      </p>

      <h6>Buy Free Spins</h6>
      <p className="card-text">
        <br />
        <img src="/ww/buyfreespins.png" alt="buyfreespins" />
        <br />
        Pay 50x your total bet to trigger Free Spin Mode with at least 5 free
        spins and a chance for more!
      </p>
      <h6>Free Spin Mode</h6>
      <p className="card-text">
        Free spins are rewarded equal to the threshold reached on the Free Spin
        Meter.
        <br />
      </p>

      <p className="card-text">
        During a round, each respin or successful combination increases the
        progress bar for free spins.
      </p>
      <br />
      <h6>Multiplier</h6>
    </>
  );
};
